import { Box } from '@mui/material'
import { getIn, useFormikContext } from 'formik'
import React from 'react'

import Input from '../Input'
import ErrorMessage from './ErrorMessage'

interface Props {
  name: string
  [otherProps: string]: any
}

const FormField: React.FC<Props> = ({ name, ...otherProps }) => {
  const { handleChange, setFieldTouched, errors, touched, values } = useFormikContext()

  return (
    <Box sx={{ mb: 2 }}>
      <Input
        fullWidth
        onBlur={() => setFieldTouched(name)}
        onChange={handleChange(name)}
        {...otherProps}
        value={getIn(values, name)}
      />
      <ErrorMessage error={getIn(errors, name)} visible={getIn(touched, name)} />
    </Box>
  )
}

export default FormField
